// src/pages/Customer/OrderTracking.jsx
import React, { useState, useEffect } from 'react';

const OrderTracking = () => {
  const [orderStatus, setOrderStatus] = useState('confirmed');
  const [timeLeft, setTimeLeft] = useState(25 * 60); // 25 minutes in seconds

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const statusSteps = [
    { id: 'confirmed', label: 'Order Confirmed', time: '10:30 AM' },
    { id: 'preparing', label: 'Preparing Food', time: '10:35 AM' },
    { id: 'ready', label: 'Ready for Pickup', time: 'Estimated 10:55 AM' },
    { id: 'delivered', label: 'Delivered', time: 'Estimated 11:05 AM' }
  ];

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-6 max-w-2xl">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold mb-2">Order #123456</h1>
          <p className="text-gray-600">Burger King • Connaught Place</p>
          <div className="mt-4 bg-red-100 text-red-800 py-2 rounded-lg">
            <span className="font-semibold">Estimated delivery: </span>
            {formatTime(timeLeft)} minutes
          </div>
        </div>

        {/* Progress Steps */}
        <div className="bg-white rounded-lg p-6 mb-6">
          <div className="space-y-4">
            {statusSteps.map((step, index) => (
              <div key={step.id} className="flex items-center">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  orderStatus === step.id ? 'bg-red-600 text-white' : 
                  index < statusSteps.findIndex(s => s.id === orderStatus) ? 'bg-green-500 text-white' : 'bg-gray-200'
                }`}>
                  {index + 1}
                </div>
                <div className="ml-4 flex-1">
                  <p className={`font-medium ${
                    orderStatus === step.id ? 'text-red-600' : 
                    index < statusSteps.findIndex(s => s.id === orderStatus) ? 'text-green-600' : 'text-gray-500'
                  }`}>
                    {step.label}
                  </p>
                  <p className="text-sm text-gray-500">{step.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Order Details */}
        <div className="bg-white rounded-lg p-6">
          <h3 className="font-semibold mb-4">Order Details</h3>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Whopper x2</span>
              <span>₹398</span>
            </div>
            <div className="flex justify-between">
              <span>French Fries</span>
              <span>₹99</span>
            </div>
            <div className="flex justify-between border-t pt-2 font-semibold">
              <span>Total</span>
              <span>₹497</span>
            </div>
          </div>
        </div>

        {/* Delivery Info */}
        <div className="bg-white rounded-lg p-6 mt-4">
          <h3 className="font-semibold mb-4">Delivery Information</h3>
          <div className="space-y-2">
            <p><span className="font-medium">Address:</span> 123 Main Street, Apartment 4B</p>
            <p><span className="font-medium">Contact:</span> +91 9876543210</p>
            <p><span className="font-medium">Delivery Partner:</span> Rahul • 📞 Call</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderTracking;